/**
 * Created by valentin on 29/06/2017.
 */
import React from 'react'
import firebase from 'firebase'
import { Redirect } from 'react-router-dom'
import { dataAppDatabase, locale } from '../../../index'
import FormRenderer from '../../common/FormRenderer/FormRenderer'

export default class NewPatientForm extends React.Component {
  constructor (props) {
    super(props)
    this.state = {}
    this.handleSubmit = this.handleSubmit.bind(this)
  }

  componentWillMount () {
    this.getConfiguration()
  }

  getConfiguration () {
    const rootRef = firebase.database().ref()
    const config = rootRef.child('riso').child('configuration')
    config.on('value', dataSnapshot => {
      this.setState({
        config: dataSnapshot.child('patientInsertionData').val()
      })
    })
  }

  handleSubmit (data) {
    const rootRef = dataAppDatabase.ref()
    const patientsRef = rootRef.child('riso').child('patientsByCountry').child(locale)
    patientsRef.push(data).then(() => {
      this.setState({
        patient: data,
        redirect: true
      })
    })
  }

  renderContent () {
    if (this.state.config) {
      return <FormRenderer
        dataKey={this.state.config.key}
        saveData={this.handleSubmit}
        title={this.state.config.title}
        extraFieldContent={this.state.config.extraFieldContent}
        fields={this.state.config.fields}
        extraFieldEnabled={this.state.config.isExtraFieldEnabled} />
    } else {
      return <div>Loading</div>
    }
  }

  render () {
    if (this.state.redirect) {
      return <Redirect to={{
        pathname: `/patients/${this.state.patient.patientNumber}`, state: {referrer: this.props.match.url}
      }} />
    }
    return (
      <div className='container'>
        <div>
          {this.renderContent()}
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/general/PatientInsertion/NewPatientForm.js